module.exports = __webpack_public_path__ + "static/media/heat-ball-1.c06155ca.gif";